import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Category } from './Category';
import { HiddenAccessibilityText } from 'Components/HiddenAccessibilityText';
import { SpecialEntitlementState } from 'Modules/CompassRights/CompassRightsContextWrapper/UserEntitlementsPanel/EntitlementsList/Entitlement/EntitlementHeader/EntitlementCategory/SpecialEntitlementState';

interface IEntitlementCategories {
  allCategories: any[];
  categories: {
    category: string;
    subCategory: string;
  };
  automatic: boolean;
  oneTime: boolean;
}

export const EntitlementCategories = ({
  allCategories,
  categories,
  automatic,
  oneTime,
}: IEntitlementCategories) => {
  return (
    <Stack direction='row' gap='16px' margin='0 0 40px 0' flexWrap='wrap'>
      <HiddenAccessibilityText
        text={
          Dictionary[DICTIONARY.CompassRights].entitlements.belongToCategory
        }
      />
      {categories?.category && (
        <Category
          mainCategory={allCategories[parseInt(categories?.category) - 1]}
          subCategory={
            allCategories[
              parseInt(categories?.category) - 1
            ]?.subCategories?.find(
              (subCat: any) => subCat.id === Number(categories?.subCategory)
            )?.name
          }
        />
      )}
      {automatic && (
        <SpecialEntitlementState
          text={Dictionary[DICTIONARY.CompassRights].entitlements.automatic}
        />
      )}
      {oneTime && (
        <SpecialEntitlementState
          text={Dictionary[DICTIONARY.CompassRights].entitlements.singleUse}
        />
      )}
    </Stack>
  );
};
